<script setup>
import { computed, useId } from 'vue'

defineOptions({ inheritAttrs: false })
const props = defineProps({
  modelValue: { type: String, default: '' },
  label: { type: String, default: '' },
  hint: { type: String, default: '' },
  error: { type: String, default: '' },
  id: { type: String, default: '' }
})
const emit = defineEmits(['update:modelValue'])
const autoId = useId()
const inputId = computed(() => props.id || autoId)
</script>

<template>
  <label class="block" :for="inputId">
    <span v-if="label" class="input-label">{{ label }}</span>
    <textarea
      v-bind="$attrs"
      :id="inputId"
      :value="modelValue"
      class="input-field min-h-24 resize-y"
      :class="error ? '!border-danger-200 !ring-danger-50' : ''"
      :aria-invalid="Boolean(error)"
      :aria-describedby="error || hint ? `${inputId}-help` : undefined"
      @input="emit('update:modelValue', $event.target.value)"
    ></textarea>
    <span v-if="error || hint" :id="`${inputId}-help`" class="mt-1.5 block text-xs font-semibold" :class="error ? 'text-danger-700' : 'text-app-muted'">
      {{ error || hint }}
    </span>
  </label>
</template>
